module.exports = __webpack_public_path__ + "static/figurine_of_wondrous_power_ebony_fly-2c00c03218cecb54874916abcc39c3f8.jpg";